import { NotificationActionType } from './notification'
import { registerRevexNotificationActions } from './actionFunctions/revex'
import { registerLeadgenNotificationActions } from './actionFunctions/leadgen'
import { registerCrmNotificationActions } from './actionFunctions/crm'
import { registerMobileNotificationActions } from './actionFunctions/mobile'
import { registerAutomationNotificationActions } from './actionFunctions/automation'

/**
 * NotificationActionService
 * 
 * A service that registers and executes action handlers for notification buttons.
 * This allows teams to define custom actions that can be triggered from notification buttons.
 */
export class NotificationActionService {
  private static actionRegistry: Record<NotificationActionType, any> | Record<string, unknown> = {};

  /**
   * Register an action handler for a specific notification action type
   * @param {NotificationActionType} type  The action type to register a handler for
   * @param {Function} handler The function to execute when this action is triggered
   */
  static registerAction(type: NotificationActionType, handler: (data?: Record<string, unknown>) => void): void {
    NotificationActionService.actionRegistry[type] = handler
  }

  /**
   * Execute the handler for a given action type with the provided data
   * @param {NotificationActionType} type The action type to execute
   * @param {Record<string, unknown>} data Optional data to pass to the action handler
   */
  static execAction(type: NotificationActionType, data?: Record<string, unknown>): void {
    if (NotificationActionService.actionRegistry[type]) {
      NotificationActionService.actionRegistry[type](data)
    } else {
      console.warn(`No action handler registered for type: ${type}`)
    }
  }
}

/**
 * Register notification action handlers during application initialization
 * This function is called from bootstrap.ts to set up all team handlers
 */
export function registerNotificationActionHandlers(store: any) {
  registerRevexNotificationActions(store)
  registerLeadgenNotificationActions(store)
  registerCrmNotificationActions(store)
  registerMobileNotificationActions(store)
  registerAutomationNotificationActions(store)
} 